/**
 * 线下培训班级列表功能
 * @Author:wuTao
 * @Date 2020/2/25
 */
import React from 'react';
import {connect} from 'dva';
import {reduxTemplateConfig, templateConfig} from './columns';

import {framework_tool, component_tool, utils_tool} from '@/tool';

let {WizContainer, WizReduxTemplate} = framework_tool;
let { WizBrowserExport} = component_tool;
let {Session} = utils_tool;

class ClassAnnouncement extends WizContainer {

  componentName = 'ClassAnnouncement';

  constructor(props) {
    super(props);

    const { history } = props
    let pathname = '/face/classList'
    if (history.location && history.location.pathname && history.location.pathname.startsWith('/perm/classListPerm')) {
      pathname = '/perm/classListPerm'
    }
    this.pathname = pathname
    let initialValue;
    if (history.location && history.location.record) {
      initialValue = history.location.record;
      Session.set('classAnnouncementManager', initialValue)
    } else {
      initialValue = Session.get('classAnnouncementManager') || {};
    }
    this.classInfoId = initialValue?.id;

    this.state = {}
  }

  /**
   * 页面动作操作后进行提示
   * @param nextProps
   * @param nextState
   * @param key
   * @returns {boolean}
   * @private
   */
  _handleClass(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['data'] && typeof(o['data']) == 'string' ? o['data'] : o['msg']);
      return true;
    } else {
      wizNotice.error(o['msg']);
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '公告名称',
        field: 'title',
        width: 30,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '公告作者',
        field: 'author',
        width: 15,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '公告发布时间',
        field: 'releaseTime',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '是否展示',
        field: 'state',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
      {
        headerName: '顺序',
        field: 'sort',
        width: 10,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      },
    ]
    if (o['success']) {
      let data = o['data']
      let stateEnum = ['否', '是']

      data.forEach(e => {
        e.state = stateEnum[e.state]
      })

      WizBrowserExport({
        title: '班级公告',
        sheetName: '班级公告',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '班级公告.xlsx',
      })
      // wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _render() {
    let _reduxTemplateConfig = reduxTemplateConfig(this, {
      classInfoId: this.classInfoId,
      templateConfig: templateConfig(this, {classInfoId: this.classInfoId}),
      apiDataFormat: {
        add: this._handleClass,
        update: this._handleClass,
        export: this._handleFile,
      },
    })
    return <WizReduxTemplate {..._reduxTemplateConfig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(ClassAnnouncement);
